import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { toggleSwitch } from '../../actions/index';
import { _ } from '../../functions/translator.js';
import { ToggleActions } from '../../constants/constants.js';

class RoadLabelSwitch extends React.Component{

    handleOnClick = () => {
        this.props.toggleSwitch(ToggleActions.ROAD_LABEL);
    };

    render() {
        return(
            <div>
                <FormGroup row>
                <FormControlLabel
                    className="text"
                    control={
                    <Switch
                        checked={ this.props.roadLabel }
                        onChange={ this.handleOnClick }
                        color="primary"
                    />
                    }
                    label={ _('Mostrar Calles') }
                />
                </FormGroup>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        roadLabel : state.switches.roadLabel,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(RoadLabelSwitch);